module.exports = __webpack_public_path__ + "static/media/eduTechImg2@2x.9ed14a92.webp";